import React, {useState, useEffect} from 'react';
import {ModalHeader, ModalBody} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import dompurify from 'dompurify';
import api from '@/api';
import {present} from '@/util';
import Icon from '@/views/shared/Icon';
import DownloadFileButton from '@/views/shared/DownloadFileButton';
import {PopError} from '@/b2b/components/Pop';
import styles from '@/b2b/index.module.css';

const ClientDetail = ({handleClick, capId}) => {
  const {t: tr} = useTranslation('clients');
  const [content, setContent] = useState('');
  const [apiError, setApiError] = useState('');

  const fetchData = () => {
    api
      .get(`/b2b/client_detail/${capId}.html`)
      .then(({data}) => {
        setContent(data);
      })
      .catch(error => {
        setApiError(error.response.data.error);
      });
  };

  useEffect(() => fetchData(), []);

  if (present(apiError)) {
    return <PopError error={String(apiError)} />;
  }

  const InnerHtml = ({html}) => {
    const cleanup = dompurify.sanitize(html);

    return <div dangerouslySetInnerHTML={{__html: cleanup}} />;
  };

  const pdfDownLoadPath = `/b2b/client_detail/${capId}.pdf`;
  const closeBtn = (
    <span
      role='button'
      tabIndex={0}
      className={styles.modal_close}
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      &times;
    </span>
  );

  return (
    <>
      <ModalHeader
        toggle={handleClick}
        close={closeBtn}
        className={styles.modal_header}
      >
        {tr('client_detail')}
      </ModalHeader>
      <ModalBody className={styles.client_details}>
        <DownloadFileButton
          className={`btn btn-outline-primary btn-sm ${styles.btn_sm}`}
          path={pdfDownLoadPath}
        >
          {tr('common:pdf_version')}
          <span>
            {' '}
            <Icon icon='file-pdf' />{' '}
          </span>
        </DownloadFileButton>
        <InnerHtml html={content} />
      </ModalBody>
    </>
  );
};

export default ClientDetail;
